import { Middleware, createSlice } from "@reduxjs/toolkit"
import { queryParams } from "./types"


type initialState = {
    response: queryParams | null
}

export const queryParamsSlice = createSlice({
    name: "queryParams",
    initialState: { response: null } as initialState,
    reducers: {
        setQueryParams(state, action) {
            state.response = action.payload
        }
    }
})


export const { setQueryParams } = queryParamsSlice.actions
export default queryParamsSlice.reducer

export const queryParamsHandlerMiddleware: Middleware = () => (next) => (action) => {
    return next(action)
}